import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

const liquidGlassInsetHighlight = 'inset 0 1px 0 color-mix(in srgb, #fff 12%, transparent)';

export const liquidGlassPillShadowSx: SystemStyleObject<Theme> = {
    boxShadow: `0 24px 56px -4px rgba(0, 0, 0, 0.54), 0 48px 128px -8px rgba(0, 0, 0, 0.42), 0 80px 240px -12px rgba(0, 0, 0, 0.30), 0 112px 336px -36px rgba(0, 0, 0, 0.18), ${liquidGlassInsetHighlight}`,
};

export const liquidGlassCircleShadowSx: SystemStyleObject<Theme> = {
    boxShadow: `0 24px 56px 0 rgba(0, 0, 0, 0.56), 0 48px 112px -4px rgba(0, 0, 0, 0.44), 0 80px 200px -8px rgba(0, 0, 0, 0.32), 0 112px 280px -20px rgba(0, 0, 0, 0.20), ${liquidGlassInsetHighlight}`,
};

export const liquidGlassRowShadowSx: SystemStyleObject<Theme> = {
    boxShadow: liquidGlassInsetHighlight,
};

export const liquidGlassSurfaceFillSx: SystemStyleObject<Theme> = {
    border: '1px solid color-mix(in srgb, var(--tg-theme-text-color) 12%, transparent)',
    bgcolor: 'color-mix(in srgb, var(--tg-theme-section-bg-color) 94%, transparent)',
    '@supports (backdrop-filter: blur(1px))': {
        backdropFilter: 'blur(16px) saturate(160%)',
        WebkitBackdropFilter: 'blur(16px) saturate(160%)',
        bgcolor: 'color-mix(in srgb, var(--tg-theme-section-bg-color) 90%, transparent)',
    },
};

export const LIQUID_GLASS_PRESS_SCALE = 1.045;

export const LIQUID_GLASS_CIRCLE_PRESS_SCALE = 1.07;

export const LIQUID_GLASS_PRESS_ORIGIN = 'center bottom';

export const liquidGlassPressTransition = { type: 'spring' as const, stiffness: 520, damping: 32 };

export const MINI_BUTTON_ACTION_SIZE = 64;
export const MINI_BUTTON_ACTION_ICON_SIZE = 22;
export const MINI_BUTTON_DOCK_GAP = 10;

export const MINI_BUTTON_DOCK_BLOCK_HEIGHT_PX = MINI_BUTTON_ACTION_SIZE + MINI_BUTTON_DOCK_GAP;

export const miniButtonDockBottomInset = `calc(var(--tg-viewport-content-safe-area-inset-bottom, 0px) + var(--tg-viewport-safe-area-inset-bottom, 0px))`;

// Reserve this as bottom padding on scrollable content behind a ButtonDock footer so the last
// item isn't left permanently hidden under the floating buttons once scrolled to the end.
export const miniButtonDockScrollBottomPad = `calc(${MINI_BUTTON_DOCK_BLOCK_HEIGHT_PX}px + ${miniButtonDockBottomInset})`;
